export default class InMemoryStorage {
  storage: { [key: string]: { value: string; expirationDate?: Date } } = {};

  getItem(key: string) {
    const data = this.storage[key];
    if (data && data.value) {
      if (data.expirationDate) {
        const now = new Date();
        if (data.expirationDate >= now) {
          return data.value;
        }

        this.removeItem(key);
        return null;
      }

      return data.value;
    }

    return null;
  }

  setItem(key: string, value: string, ttl?: number) {
    let expirationDate;
    if (ttl) {
      expirationDate = new Date();
      expirationDate.setSeconds(expirationDate.getSeconds() + ttl);
    }

    this.storage[key] = { value, expirationDate };
  }

  removeItem(key: string) {
    delete this.storage[key];
  }
}
